<template>
    <section>
        <h1>Browse More Profiles</h1>
        <div class="more-profiles">
            <div class="profile-link" v-for="member in browseMembers">
                <a :href="`/Profile/${member.stringUrl}`"><img :src="avatarImage(member)"/><span class="member-name">{{member.alias}}</span></a>
            </div>
        </div>
    </section>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'BrowseMoreProfiles',
        props: ['currentMemberId'],

        data() {
            return {
                browseMembers: []
            }
        },

        methods: {
            avatarImage(user){
                let avatarId = new Date(user.avatarUpdate).getTime();
                if (user.hasAvatar) {
                    return `/userdata/avatars/${user.id}.jpg?v=${avatarId}`;
                } else {
                    return '/defaultProfilePic.png';
                }
            },
        },

        mounted(){
            axios.get('/api/browseMembers', {
                params: {
                    currentMemberId: this.currentMemberId
                }
            }).then(
                (response) => {
                    if (response.errors) {
                        return;
                    }

                    this.browseMembers = response.data.members;
                }
            )
        }
    }
</script>


// WEBPACK FOOTER //
// BrowseMoreProfiles.vue?2b0d3192